import { SearchRequest } from '@com-delta-idp/mnx-sitewide-shared-utils';
import { MessageBanner } from '@com-delta-omnichannel/mach-core-js';
import {
  bannerOptions,
  codes,
  Color_Codes,
  Colors,
  Colors_s,
  Flyout,
  IRPC_NO_PROT,
  IRPC_PROT,
  MessageBannerType,
  stickyBanner
} from '../../models/constants/today.constants';
import { FlyoutToday, Message } from '../../models/interfaces/today.models';

const normalizedCodes: Record<string, string> = Object.keys(codes).reduce(
  (acc, key) => {
    acc[key.replace(/ /g, '_')] = (codes as Record<string, string>)[key];
    return acc;
  },
  {} as Record<string, string>
);

export class FlyoutTodayExtendedComponent {
  messageBanner!: MessageBanner;
  hideIROPClose = false;
  showIropModel = false;
  awsFlag = false;
  showDefaultBanner = false;

  getIROPTypeChange(errorCode: string): MessageBannerType {
    const colorMap: Record<string, MessageBannerType> = {
      [Color_Codes.green]: MessageBannerType.CONFIRMATION,
      [Color_Codes.orange]: MessageBannerType.WARNING,
      [Color_Codes.red]: MessageBannerType.ERROR
    };
    return (
      colorMap[this.getIROPColorChange(errorCode)] ??
      MessageBannerType.CONFIRMATION
    );
  }

  showErrorMessage(id: string, message: Message, errorCode?: string) {
    bannerOptions.id = id;
    bannerOptions.content.description = message.errorMessageDescription;
    bannerOptions.content.header.title =
      message.errorMessageTitle && errorCode ? message.errorMessageTitle : '';
    if (errorCode) {
      bannerOptions.type = this.getIROPTypeChange(errorCode);
    }

    this.messageBanner = new MessageBanner(bannerOptions);
  }

  getAeroStatusType(colorCode: string): Colors_s {
    const code = colorCode?.toUpperCase();
    return code === Colors.RED
      ? Colors_s.red
      : code === Colors.ORANGE || code === Colors.YELLOW
        ? Colors_s.orange
        : Colors_s.green;
  }

  getIROPColorChange(errorCode: string): string {
    if (
      [IRPC_PROT, IRPC_NO_PROT, 'IRPC_NO_PROT'].includes(
        errorCode?.toUpperCase()
      )
    ) {
      this.hideIROPClose = true;
    }
    return this.getColour(errorCode);
  }

  getColour(errorCode: string): string {
    return (
      normalizedCodes[errorCode?.toUpperCase().replace(/ /g, '_')] ??
      Color_Codes.green
    );
  }

  showBanner(content: FlyoutToday) {
    if (content.showIropModel) {
      this.showErrorMessage(
        stickyBanner.msg_Banner,
        content.errorMessages,
        content.todayTrip.iropMessage
      );
    }

    if (
      !content.todayTrip.departureCityCode &&
      content.errorMessages.errorMessageDescription
    )
      this.showErrorMessage(stickyBanner.err_Banner, content.errorMessages);
  }

  showDefaultMessage(defaultErrorMessage?: Message) {
    this.showDefaultBanner = true;
    // Defer to allow Angular change detection to process the banner visibility toggle
    // before creating a new MessageBanner instance on the updated DOM.
    if (defaultErrorMessage) {
      setTimeout(() => {
        this.showErrorMessage(stickyBanner.def_Banner, defaultErrorMessage);
      });
    }
  }

  checkMessageBanner(iropErrorMessage: boolean): boolean {
    return iropErrorMessage && !this.showDefaultBanner;
  }

  tripDetailsRedirect(content: FlyoutToday): void {
    const request: SearchRequest = {
      searchType: Flyout.CONFIRMATION_NO,
      recordLocator: content.todayTrip?.recordLocator,
      lastName: content.todayTrip?.lastName,
      firstName: content.todayTrip?.firstName
    };
    sessionStorage.setItem(Flyout.TRIP_REQUEST, JSON.stringify(request));
    window.location.href = Flyout.TRIP_DETAILS_URL;
  }
}
